import { IRootState } from '../../../store'
import { IPatientDemographicsState } from '../store/patientDemographics.types'

export const getPatientDemographicsSelector = (state: IRootState): IPatientDemographicsState =>
  state.patientDemographics
